export default __webpack_public_path__ + "49abdd5dddcb5534d7002bdefbe0fb7c.png";